export enum AppointmentReferralReviewStatus {
  accepted = 'accepted',
  rejected = 'rejected',
}
